<template>
  <div class="app-container">
    <el-card class="box-card">
      <folded-panel infoName="基本信息">
        <div slot="content">
          <dynamic-form
            labelWidth="120px"
            :formConfig="formConfig"
            v-model="form"
            :disabled="!isEdit"
            :showBtn="false"
            ref="form"
          />
        </div>
      </folded-panel>
      <data-box
        v-if="!id"
        hostUrl="/bs-project-milestone"
        :props="{label: 'name',value: 'id'}"
        :tableColumn="dataBoxHead"
        :multiple="false"
        :extendParms="{ foundNumber:form.projectType}"
        :trigger="{btnType:'button',title:'导入模板'}"
        v-model="importArr"
        @confirm="(val) => mbimport(val)"
      ></data-box>
      <folded-panel infoName="项目阶段">
        <div slot="content">
          <edit-data-table
            :head="tableHead3"
            :data.sync="tableData3"
            :config="{trigger: 'click', mode: 'cell',activeMethod: activeMethod , autoClearActive:false}"
            :edit-rules="validRules"
            :editable="isEdit"
            :showAdd="isEdit"
            max-height="500px"
            ref="projectStage"
          >
            <template #code="{$index}">
              <span>{{$index+1}}</span>
            </template>
            <template #bsMilestoneNode="{row}">
              <span>{{row.bsMilestoneNode? row.bsMilestoneNode.name:''}}</span>
            </template>
            <template #bsMilestoneNodeEdit="{row}">
              <data-box
                hostUrl="/bsMilestoneNode"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="dataBoxHead"
                :multiple="false"
                :disabled="row.id"
                v-model="row.bsMilestoneNode"
                @confirm="(val) => {row.milestoneNode = val.id}"
              ></data-box>
            </template>
            <template #receipt="{row}">
              <span>{{row.receipt ? row.receipt.label: ""}}</span>
            </template>
            <template #receiptEdit="{row}">
              <data-box
                :props="{label: 'label',value: 'id'}"
                :tableColumn="receiptHead"
                :tableData="paymentDetails"
                :multiple="false"
                v-model="row.receipt"
                @confirm="(val) => {row.receiptId = val.id}"
              ></data-box>
            </template>
             <template #actualCost="{row}">
              <el-tag type="warning" v-if="row.yellow >= 70 && row.yellow < 90 ">{{row.actualCost}}</el-tag>
              <el-tag type="danger" v-else-if="row.yellow >= 90">{{row.actualCost}}</el-tag>
              <span v-else>{{row.actualCost}}</span>
            </template>
            <template #latestFinishTime="{row}">
              <span v-if="row.actualCompletionTime !== null">{{row.latestFinishTime}}</span>
              <el-tag type="warning" v-else-if="row.differNumber >= 70 && row.differNumber < 90 ">{{row.latestFinishTime}}</el-tag>
              <el-tag type="danger" v-else-if="row.differNumber >= 90">{{row.latestFinishTime}}</el-tag>
              <span v-else>{{row.latestFinishTime}}</span>
            </template>
            <template #keyOutsList="{row}">
              <span v-for="(item, index) in row.keyOutsList" :key="item.id">{{item.name}}{{index &lt; row.keyOutsList.length-1 ? ',' : ''}}</span>
            </template>
            <template #keyOutsListEdit="{row}">
              <data-box
                hostUrl="/bsKeyOuts"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="dataBoxHead"
                :multiple="true"
                :disabled="true"
                v-model="row.keyOutsListArr"
                @confirm="(val) => {row.keyOutsList = val;const newArr = val.map((item) => { return item.id });row.keyOutput = newArr.join()? newArr.join():null}"
              ></data-box>
            </template>
            <template #toolbar="scope">
              <el-popover :ref="scope.$index + 'a'" placement="top" width="180" v-if="!scope.row.id">
                <p>确定删除本条数据吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="$refs[scope.$index + 'a'].doClose()">取消</el-button>
                  <el-button type="primary" size="mini" @click="delMilestonePlans(scope.row.id,scope)">确定</el-button>
                </div>
                <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
              </el-popover>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <folded-panel infoName="费用明细">
        <div slot="content">
          <edit-data-table
            :head="tableHead2"
            :data.sync="tableData2"
            :config="{trigger: 'click', mode: 'cell',autoClearActive:false}"
            :edit-rules="costRules"
            :editable="false"
            :showAdd="false"
            max-height="400px"
            ref="expense"
          >
            <template #bsProjectBudget="{row}">
              <span>{{row.bsProjectBudget? row.bsProjectBudget.name:''}}</span>
            </template>
            <template #bsProjectBudgetEdit="{row}">
              <data-box
                hostUrl="/bsProjectBudget"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="dataBoxHead"
                :multiple="false"
                v-model="row.bsProjectBudget"
                @confirm="(val) => {row.budgetItem = val.id}"
              ></data-box>
            </template>
            <template #toolbar="scope">
               <el-popover :ref="scope.$index + 'b'" placement="top" width="180" v-if="false">
                <p>确定删除本条数据吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="$refs[scope.$index + 'b'].doClose()">取消</el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="delChargeDetails(scope.row.id,scope)">确定
                  </el-button>
                </div>
                <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
              </el-popover>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <folded-panel infoName="可支配人员">
        <div slot="content">
          <edit-data-table
            :head="tableHead4"
            :data.sync="tableData4"
            :config="{trigger: 'click', mode: 'cell',autoClearActive:false}"
            :editable="true"
            :showAdd="false"
            max-height="400px"
            ref="person"
          >
            <template #person="{row}">
              <span>{{row.person? row.person.name:''}}</span>
            </template>
            <template #personEdit="{row}">
              <data-box
                hostUrl="/bs-person/getList"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="dataBoxHead"
                :multiple="false"
                :disabled='true'
                v-model="row.person"
                @confirm="(val) => {row.staff = val.id;row.settlementPrice = val.rankEntity.settlementUnitPrice || 0}"
              ></data-box>
            </template>
             <template #projectRoles="{row}">
              <span>{{row.projectRoles? row.projectRoles.name:''}}</span>
            </template>
            <template #projectRolesEdit="{row}">
              <data-box
                hostUrl="/bsProjectRoles"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="dataBoxHead"
                :multiple="false"
                v-model="row.projectRoles"
                 @confirm="(val) => {row.projectRole = val.id}"
              ></data-box>
            </template>
            <template #releaseStatusEdit="{row}">
              <span>{{row.releaseStatus == 1? '借用':'占用'}}</span>
            </template>

          </edit-data-table>
        </div>
      </folded-panel>
       <folded-panel infoName="收款明细">
        <div slot="content">
          <edit-data-table
            :head="paymentDetailHead"
            :data.sync="paymentDetails"
            :config="{trigger: 'click', mode: 'cell'}"
            :editable="false"
            :showAdd="false"
            :toolBar="{ hidden: true}"
            max-height="400px"
          >
           <template #moneyId="{row}">
              <div v-for="item in receiptTypes" :key="item.id">
                <div v-if="row.moneyId && row.moneyId.toString() === item.value">{{item.label}}</div>
              </div>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <div class="button">
        <el-button class="btn-submit" v-if="isEdit" :loading="loading" @click="save(1)">变更确认</el-button>
        <el-button class="btn-cancel" @click="cancel">取消</el-button>
      </div>
      <drag-dialog :show="stepShow" :title="'审批人选择'" :width="'40%'" @close="close">
        <PersonStep :data="personStepData" @submit="submitConfirm" @close="close"></PersonStep>
      </drag-dialog>
    </el-card>
  </div>
</template>

<script>
import FoldedPanel from "@/components/FoldedPanel";
import "@/components/dynamic-form";
import "@/components/EditDataTable";
import DataBox from "@/components/dynamic-form/dynamic-data-box";
import { parseTime } from "@/utils";
import initDict from "@/mixin/initDict";
import { tableSataus } from "@/views/bill/mixins/status";
import CrudMixin from "@/mixins/CrudMixin";
import {findContractById} from "@/api/bill/contract";
import {
  getProjectDelivery,
  changeProjectDelivery,
  delLaborCosts,
  delChargeDetails,
  delMilestonePlans,
  delBonusPlans,
  delBonuses,
  delDisposablePeople,deliveryIsFinish
} from "@/api/basic";
import { idQuery } from "@/api/basic/projectPhase";
import { getDocumentCode } from "@/views/utils";
import DragDialog from "@/components/DragDialog"
import { getFlowNode } from "@/api/hrApproval"
import PersonStep from "@/components/PersonStep";
import { getDeptAndChildrenTree } from "@/api/dept";
export default {
  name: "DeliveryChangeForm",
  components: {
    FoldedPanel,
    DataBox,DragDialog,PersonStep
  },
  mixins: [initDict, tableSataus,CrudMixin],
  data() {
    return {
      daoru: false,
      isEdit: true,
      loading: false,
      dialogShow: false, // 提交弹窗
      dialogForm: {
        formItemList: [
          // {
          //   label: "审批人1",
          //   key: "proposer",
          //   type: "databox",
          //   placeholder: "请选择人员",
          //   span: 8,
          //   props: {
          //     label: "name",
          //     value: "id"
          //   },
          //   // url: "/bs-person/getList",
          //   tableColumn: [
          //     { property: "code", label: "编码", align: "center", query: { type: "input" }},
          //     { property: "name", label: "名称", align: "center", query: { type: "input" }}
          //   ],
          //   tableData: [],
          //   // extendParms: { queryFieldItem: "id,number,name" },
          //   multiple: false,
          //   rules: {
          //     required: true,
          //     message: "不能为空",
          //     trigger: "change"
          //   }
          // },
        ]
      },
      keyOutsListArr: [],
      importArr: [],
      contractIds: "",
      tableData: [],
      tableData1: [],
      formConfig: {
        formItemList: [
          {
            type: "input",
            key: "billState",
            label: "立项状态",
            value: "",
            placeholder: "请输入标题",
            span: 8,
            hidden: true,
            disabled: true
          },
          {
            type: "input",
            key: "code",
            label: "单据编号",
            value: "",
            placeholder: "请输入标题",
            span: 8,
            disabled: true
          },
          {
            label: "项目名",
            key: "projectObj",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: "code"
            },
            url: "/bsProject",
            tableColumn: [
              {
                property: "code",
                label: "项目号"
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { searchType: 1 },
            multiple: false,
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "change",
            }],
            disabled: true
          },
           {
            label: "项目号",
            key: "projectNumber",
            type: "input",
            span: 8,
            disabled: true
          },
          {
            type: "select",
            label: "立项类型",
            key: "projectType",
            span: 8,
            options: [],
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "change"
            }],
            disabled: true
          },
          {
            label: "合同",
            key: "contract",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: "id"
            },
            url: "/bizContract",
            tableColumn: [
              {
                property: "code",
                label: "编码"
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: {billState: 3},
            multiple: false,
            disabled: true
            // rules: [{
            //   required: true,
            //   message: "不能为空",
            //   trigger: "change"
            // }]
          },
          {
            label: "经营人",
            key: "operatorObj",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: "id"
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "code",
                label: "编码",
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,code,name" },
            multiple: false,
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "change"
            }]
          },
          {
            type: "treeSelect",
            label: "所属部门",
            key: "departmentId",
            clearable: true,
            filterable: true,
            span: 8,
            props: {
              label: 'name',
              value: 'id',
              children: 'children'
            },
            options: [],
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "change"
            }]
          },
          // {
          //   type: "input",
          //   key: "number",
          //   label: "合同号",
          //   value: "",
          //   placeholder: "请输入标题",
          //   span: 8,
          //   rules: [
          //     {required: true, message: "标题不能为空", trigger: "blur"}
          //   ]
          // },
          {
            label: "项目经理",
            key: "projectManagerObj",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: "id"
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "code",
                label: "编码",
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,code,name" },
            multiple: false,
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "change"
            }]
          },
           {
            type: "number",
            key: "budget",
            label: "费用预算",
            value: "",
            disabled: true,
            span: 8
          },
          {
            type: "number",
            key: "budgetBalance",
            label: "费用预算结余",
            value: "",
            disabled: true,
            span: 8
          },
          {
            type: "number",
            key: "costBudgeting",
            label: "交付成本",
            value: "",
            span: 8,
             rules: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }],
            disabled: true
          },
           {
            type: "number",
            key: "riskFundTotal",
            label: "风险金预算",
            value: "",
            span: 8,
             rules: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }],
            disabled: true
          },
          {
            type: "number",
            key: "riskFundBalance",
            label: "风险金结余",
            value: "",
            disabled: true,
            span: 8
          },
           {
            type: "number",
            key: "targetCost",
            label: "人工目标成本",
            value: "",
            span: 8,
             rules: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }],
            disabled: true
          },
           {
            type: "number",
            key: "costForecast",
            label: "人工成本预算",
            value: "",
            placeholder: "请输入数值",
            span: 8,
            disabled: true
          //   rules: [{
          //     required: true,
          //     message: "不能为空",
          //     trigger: "blur",
          //   },
          //     {
          //   validator(rule, value, callback) {
          //     const reg = /^\d+\.?(\d{1,2})?$/
          //     if (reg.test(value)) {
          //       callback();
          //     } else {
          //       callback(new Error("小数点后保留两位"));
          //     }
          //   },
          //   trigger: "blur"
          // }
          //   ]
          },
          {
            type: "number",
            key: "costBalance",
            label: "人工成本结余",
            value: "",
            disabled: true,
            span: 8
          },
          {
            span: 8,
            key: "planCloseTime",
            value: null,
            placeholder: "请选择",
            type: "date",
            label: "计划结项日期",
            valueFormat: "yyyy-MM-dd",
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }],
            disabled: true
          },
           {
            span: 8,
            key: "created",
            value: null,
            placeholder: "请选择",
            type: "date",
            label: "创建日期",
            valueFormat: "yyyy-MM-dd",
            disabled: true
          },
          {
            type: "number",
            key: "collectMoney",
            label: "收款金额",
            value: "",
            disabled: true,
            span: 8
          },
          {
            type: "input",
            key: "customerMain",
            label: "终端客户",
            disabled: true,
            value: "",
            span: 8
          },
          {
            span: 8,
            key: "checkDate",
            value: null,
            placeholder: "请选择",
            type: "date",
            disabled: true,
            label: "验收日期",
            valueFormat: "yyyy-MM-dd",
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }]
          },
          {
            span: 8,
            key: "maintenanceDate",
            value: null,
            placeholder: "请选择",
            type: "date",
            disabled: true,
            label: "维保日期",
            valueFormat: "yyyy-MM-dd",
            rules: [{
              required: true,
              message: "不能为空",
              trigger: "blur"
            }]
          }, {
            type: "textarea",
            key: "remark",
            label: "备注",
            value: "",
            span: 16,
            maxlength: 200,
            disabled: true
          }
        ]
      },
      form: {},
      tableHead: [
        {
          label: "人员",
          prop: "person",
          editRender: { type: "default" }
        },
        {
          label: "结算单价",
          prop: "settlementPrice",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "项目角色",
          prop: "projectRoles",
          editRender: { type: "default" }
        },
        {
          label: "项目消耗人天",
          prop: "projectConsumption",
          editRender: {
            type: "default",
            name: "ElInputNumber",
            props: { placeholder: "请输入数值" }
          }
        },
        {
          label: "项目耗费成本",
          prop: "projectCost",
          editRender: {
            type: "default",
            name: "ElInputNumber",
            props: { placeholder: "请输入数值" }
          },
          // formatter: (val, row) => {
          //   return (
          //     parseInt(row.settlementPrice) *
          //       parseInt(row.projectConsumption) || ""
          //   );
          // }
        },
        {
          label: "备注",
          prop: "remark",
          editRender: { type: "default", name: "ElInput" }
        }
      ],
      tableHead2: [
        {
          label: "预算项目",
          prop: "bsProjectBudget",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "预算金额",
          prop: "budgetAmount",
          editRender: { type: "default",name: "ElInput", props: { placeholder: "请输入数值" } }
        },
        {
          label: "耗费金额",
          prop: "amountSpent",
          editRender: {
            type: "default",
            name: "ElInput",
            props: { disabled: true }
          }
        },
        {
          label: "结余金额",
          prop: "balance",
          editRender: {
            type: "default",
            name: "ElInput",
            props: { disabled: true }
          },
          formatter: (val, row) => {
            return this.$numberUtils.sub(row.budgetAmount, row.amountSpent);
          }
        },
        {
          label: "备注",
          prop: "remark",
          editRender: { type: "default", name: "ElInput" }
        }
      ],
      tableHead3: [
        {
          label: "序号",
          prop: "code",
          width: '60px',
        },
        {
          label: "项目阶段",
          prop: "bsMilestoneNode",
          width: '120px',
          editRender: { type: "default" }
        },
        {
          label: "阶段描述",
          prop: "remark",
          width: '120px',
          editRender: { type: "default", name: "ElInput", props: {disabled: true } }
        },
        {
          label: "款项说明",
          prop: "receipt",
           width: '120px',
          editRender: {  type: "default"}
        },
        // {
        //   label: "对应项目节点",
        //   prop: "bsProjectNode",
        //   editRender: { type: "default"}
        // },
        // {
        //   label: "工作目标描述",
        //   prop: "workTargetDetail",
        //   editRender: { type: "default", name: "ElInput" }
        // },
        {
          label: "计划开始时间",
          prop: "expectedStartTime",
          width: '140px',
          editRender: {
            name: "ElDatePicker",
            props: { type: "date", valueFormat: "yyyy-MM-dd"}
          }
        },
        {
          label: "计划完成时间",
          prop: "latestFinishTime",
           width: '140px',
          editRender: {
            name: "ElDatePicker",
            props: {type: "date", valueFormat: "yyyy-MM-dd"}
          }
        },
        //  {
        //   label: "是否完成",
        //   prop: "isFinish",
        //   editRender: { type: "default", name: "ElInput", props: {disabled: true }},
        //   formatter: (val, row) => {
        //     return val === 1 ? '已完成' : '未完成'
        //   }
        // },
        {
          label: "实际完成时间",
          prop: "actualCompletionTime",
           width: '140px',
          editRender: {
            name: "ElDatePicker",
            props: { type: "date", valueFormat: "yyyy-MM-dd", disabled: true}
          }
        },
        {
          label: "收入",
          prop: "gain",
          width: '120px',
          editRender: { type: "default", name: "ElInputNumber", props: {controls: false} }
        },
         {
          label: "预计消耗成本",
          prop: "planCost",
           width: '140px',
          editRender: { type: "default", name: "ElInput", props: {disabled: true } }
        },
        {
          label: "已分配成本",
          prop: "verifyAmount",
          width: '140px',
        },
        {
          label: "已汇报成本",
          prop: "actualAmount",
          width: '140px',
        },
        {
          label: "实际消耗成本",
          prop: "actualCost",
           width: '140px',
          editRender: { type: "default", name: "ElInput" , props: {disabled: true }}
        },
         {
          label: "风险金",
          prop: "riskFund",
          width: '100px',
          editRender: { type: "default", name: "ElInput", props: {disabled: true }}
        },
        {
          label: "风险金占比",
          prop: "riskPercent",
           width: '140px',
          editRender: { type: "default", name: "ElInput" , props: {disabled: true }}
        },
        {
          label: "关键输出物",
          prop: "keyOutsList",
           width: '120px',
          editRender: { type: "default" , disabled: true }
        }
      ],
      tableHead4: [
        {
          label: "人员",
          prop: "person",
          editRender: { type: "default", }
        },
        {
          label: "结算单价",
          prop: "settlementPrice",
          editRender: {
            type: "default",
            name: "ElInput",
            props: { placeholder: "请输入数值" ,disabled: true}
          },
        },
        {
          label: "项目角色",
          prop: "projectRoles",
          editRender: { type: "default",}
        },
        // {
        //   label: "总占用天数",
        //   prop: "applyDay",
        //   editRender: { type: "default", name: "ElInput" }
        // },
        //  {
        //   label: "剩余天数",
        //   prop: "applyDaysRemainig",
        //   editRender: { type: "default", name: "ElInput" }
        // },
         {
          label: "实际消耗人天",
          prop: "projectConsumption",
          editRender: { type: "default", name: "ElInput" ,props: { disabled: true}},
          formatter: (val,row) => {
            if (val && val !== null && val !== '') {
              return val;
            } else {
              return '0';
            }
          }
        },
          {
          label: "实际耗费成本",
          prop: "projectCost",
          editRender: { type: "default", name: "ElInput",props: {disabled: true } },
          formatter: (val,row) => {
            if (val && val !== null && val !== '') {
              return val;
            } else {
              return '0';
            }
          }
          // formatter: (val, row) => {
          //   return (
          //     parseInt(row.settlementPrice) *
          //       parseInt(row.projectConsumption) || ""
          //   );
          // }
        },
        {
          label: "是否是借用",
          prop: "releaseStatus",
           formatter: (val, row) => {
            return val === 1 ? '借用' : '占用'
          }
        },
      ],
      tableHead5: [
        {
          label: "项目角色",
          prop: "projectRoles",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "人员",
          prop: "person",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "分配比例",
          prop: "ratio",
          editRender: {
            type: "default",
            name: "ElInput",
            props: { placeholder: "请输入数值" }
          }
        },
        {
          label: "发放条件",
          prop: "conditions",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "备注",
          prop: "remark",
          editRender: { type: "default", name: "ElInput" }
        }
      ],
      tableHead6: [
        {
          label: "条件",
          prop: "conditions",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "奖金额",
          prop: "prizeAmount",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "备注",
          prop: "remark",
          editRender: { type: "default", name: "ElInput" }
        }
      ],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      tableData5: [],
      tableData6: [],
      dataBoxHead: [
        { label: "编码", property: "code" },
        { label: "名称", property: "name", query: { type: "input" } },
        { label: "备注", property: "remark" }
      ],
      projectCostSum: 0, // 项目耗费成本总和
      validRules: {
        bsMilestoneNode: [{ required: true, message: "不能为空", trigger: "blur" }],
        receipt: [{ required: true, message: "不能为空", trigger: "blur" }]
      },
      costRules: {
        bsProjectBudget: [{ required: true, message: "不能为空", trigger: "blur" }],
        budgetAmount: [{ required: true, message: "不能为空", trigger: "blur" ,type: 'number'},
         {
            validator(rule, value, callback) {
              const reg = /^\d+\.?(\d{1,2})?$/
              if (reg.test(value)) {
                callback();
              } else {
                callback(new Error("小数点后保留两位"));
              }
            },
            trigger: "change"
          }]
      },
      validateRefNames: ['form', 'projectStage', 'expense'],
      form2: {}, // hr审批
      assignData: {},// hr审批人员信息
      paymentDetailHead: [
          {
            label: "款项说明",
            prop: "moneyId",
            editRender: {
              type: "default",
              name: "ElSelect",
              options: []
            }
          },
          {
            label: "金额",
            prop: "totals",
            editRender: { type: "default", name: "ElInput" }
          },
          {
            label: "已收金额",
            prop: "receivedMoney",
            editRender: {
              type: "default",
              name: "ElInput",
              props: { disabled: true }
            }
          },
          {
            label: "未收金额",
            prop: "uncollectedMoney",
            editRender: {
              type: "default",
              name: "ElInput",
              props: { disabled: true }
            },
            formatter: (val, row) => {
              const value = parseInt(row.totals) - parseInt(row.receivedMoney ? row.receivedMoney : 0);
              row.uncollectedMoney = value;
              return value || ''
            }
          },
          {
            label: "付款条件",
            prop: "conditions",
            editRender: { type: "default", name: "ElInput" }
          },
          {
            label: "备注",
            prop: "remark",
            editRender: { type: "default", name: "ElInput" }
          }
        ],
        paymentDetails: [],
        contractDetailId: '',
        receiptTypes: [], // 收款方式
        stepShow: false,
        personStepData: [],
        contractId2: '',
        riskSum: 0,
        receiptHead: [
          { label: "款项说明", property: "label", },
          { label: "金额", property: "totals"},
          { label: "已收金额", property: "receivedMoney" },
          { label: "未收金额", property: "uncollectedMoney" }
        ]
    };
  },
  watch: {
    "form.projectObj": {
      handler(val) {
        if (val) {
          this.form.projectNumber = val.code;
        }
      },
      deep: true
    },
    'form.riskFundTotal': { // 计算人工成本预算
      handler(val,oldVal) {
        if (val && this.form.targetCost && val !== oldVal) {
          this.form.costForecast = parseInt(this.form.targetCost) - parseInt(val)
        }
        // if  (this.tableData3.length <= 0) { // 风险金结余
        //   this.form.riskFundBalance = parseInt(this.form.riskFundTotal)
        // }
        if  (this.tableData4.length <= 0) { // 人工成本结余
          this.form.costBalance = parseInt(this.form.costForecast)
        }
      },
      deep: true
    },
     'form.targetCost': { // 计算人工成本预算
      // handler(val,oldVal) {
      //   if (val && this.form.riskFundTotal && val !== oldVal) {
      //     this.form.costForecast = parseInt(val) - parseInt(this.form.riskFundTotal)
      //   }
      // },
      handler(val) {
        if (val) { // 计算人工成本预算
          this.form.costForecast = parseInt(val) - parseInt(this.form.riskFundTotal)
        }
         if  (this.tableData4.length <= 0) { // 人工成本结余
          this.form.costBalance = parseInt(this.form.costForecast)
        }
      },
      deep: true
    },
    'form.contract': {
      handler(val,oldVal) {
        if (val && val !== oldVal) {
          const id = this.contractDetailId ? this.contractDetailId : val.id
          this.contractId2 = val.id
          findContractById(id).then(res => {
            this.paymentDetails = res.data.bizPaymentDetails
            if (this.paymentDetails.length <= 0) {
                this.form.collectMoney = 0
            } else {
               this.form.collectMoney = 0
              for (const i of this.paymentDetails) {
              this.form.collectMoney += (parseInt(i.receivedMoney || 0))
              }
            }
          })
        }
      },
      deep: true
    },
    'form.projectType': {
      handler(val,oldVal) {
        if (val && val !== oldVal) {
          const idx = this.formConfig.formItemList.findIndex(i => i.key === 'projectManagerObj')
          if (idx !== -1) {
            let label = '项目经理'
            // 售前项目
            if (val === 'SQXM') {
              label = '销售负责人'
            }
            this.$set(this.formConfig.formItemList[idx], 'label', label)
          }
        }
      },
      immediate: true
    },
    tableData2: {
      handler(val,oldVal) {
        if (val.length <= 0) {
          this.form.budget = 0
          this.form.budgetBalance = 0
        } else {
          this.form.budget = 0
          this.form.budgetBalance = 0
        for (const i of val) {
        this.form.budget += (parseInt(i.budgetAmount) || 0); // 计算费用预算
        this.form.budgetBalance += (parseInt(i.budgetAmount) || 0) - (parseInt(i.amountSpent) || 0);
        // i.balance = parseInt(i.budgetAmount) - parseInt(i.amountSpent) || i.budgetAmount; // 结余金额
        }
      }
      },
      deep: true
    },
    tableData3: {
      handler(val,oldVal) {
        this.riskSum = 0
        val.forEach((item,index) => {
          item.code = index + 1
          item.yellow = (parseInt((item.actualCost) || 0) / parseInt((item.planCost) || 0)) * 100
          if (item.expectedStartTime) {
            if (item.latestFinishTime) {
              item.planNumber = this.getEndDate(parseTime(item.expectedStartTime, "{y}-{m}-{d}"),parseTime(item.latestFinishTime, "{y}-{m}-{d}")) + 1
            }
            item.nowNumber = this.getEndDate(parseTime(item.expectedStartTime, "{y}-{m}-{d}"),parseTime(new Date(), "{y}-{m}-{d}")) + 1
          }
          item.differNumber = (parseInt(item.nowNumber) / parseInt(item.planNumber)) *  100
           this.riskSum += parseInt(item.riskFund)
          // 风险金结余= 风险金预算-风险金之和
          this.form.riskFundBalance = parseInt(this.form.riskFundTotal) - (parseInt(this.riskSum) || 0)
        })
      },
      deep: true
    },
    tableData4: {
      handler(val,oldVal) {
          if (val.length <= 0) {
            this.form.costBalance = parseInt(this.form.costForecast)
          } else {
             this.form.costBalance = 0;
            this.projectCostSum = 0;
            for (const i of val) {
              this.projectCostSum += parseInt(i.projectCost || 0);
              // 人工成本结余= 人工成本预算-项目耗费成本之和
              this.form.costBalance =  (parseInt(this.form.costForecast) - (this.projectCostSum)) || 0
               console.log('人工成本结余..',this.projectCostSum,this.form.costBalance)
            }
            // for (const i of val) {
            //   this.projectCostSum += parseInt(i.projectCost)
            //   // 人工成本结余= 人工成本预算-项目耗费成本之和
            //   this.form.costBalance =  (parseInt(this.form.costForecast) - (this.projectCostSum)) || 0
            //    console.log('人工成本结余..',this.projectCostSum,this.form.costBalance)
            // }
          }
      },
      deep: true
    }
  },
  created() {
    this.id = this.$route.params.id;
    this.isEdit = this.$route.params.isEdit !== undefined ? Boolean(Number(this.$route.params.isEdit)) : true;
    this.getDeptTreeInterface(); // 获取部门
    if (this.id) {
      getProjectDelivery(this.id).then(res => {
        const form = res.data.projectDelivery;
        this.tableData4 = res.data.disposablePersonList;
        if (form.projectNumber && form.projectName) {
          form.projectObj = { code: form.projectNumber, name: form.projectName };
        }
        form.operatorObj = form.person;
        if (form.contractDelivery == null) {
          this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'contract')].disabled = false;
        }
        // form.projectLeader = { id: form.projectLeader, name: form.leader };
        form.projectManagerObj = form.personManager;
        // form.cNumber = {code: form.cnumber ,name: form.cnumber,}
        if (form.contractDelivery) {
          form.contract = {
            code: form.contractDelivery.contractCode,
            id: form.contractDelivery.contractId,
            name: form.contractDelivery.contractName,
            totals: form.contractDelivery.totals
            }
          this.contractIds = form.contractDelivery.id
          this.contractDetailId = form.contractDelivery.contractId
        }
        form.collectMoney = ''
        if (form.bsProject && form.bsProject.customer) {
          form.customerMain = form.bsProject.customer.name || ''
        }
        this.form = form;
        this.tableData = res.data.laborCosts;
        this.tableData2 = res.data.chargeDetails;
        this.tableData3 = res.data.milestonePlans;
        this.tableData3.forEach(item => {
          item.keyOutsListArr = item.keyOutsList
            item.receipt = item.bizPaymentDetails
          })
        this.tableData5 = res.data.bonusPlans;
        this.tableData6 = res.data.bonuses;
      });
    } else {
      this.form.created = new Date()
      this.form.code = getDocumentCode("LXJF");
    }
    // 立项类型
    this.getDict("project_type").then(res => {
      this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'projectType')].options = res.data;
    });
      // 款项说明
    this.getDict("RECEIPT").then(res => {
      this.receiptTypes = res.data;
      this.$set(this.tableHead3[this.tableHead3.findIndex(item => item.prop === 'receipt')].editRender,'options',res.data)
    });
  },
  methods: {
    getDeptTreeInterface() {
      // 开发部门
      getDeptAndChildrenTree(`${process.env.VUE_APP_TREEID}`).then(res => {
        const obj = this.formConfig.formItemList[this.formConfig.formItemList.findIndex(item => item.key === 'departmentId')]
        this.$set(obj,'options',res.data)
      });
    },
    releaseStatusFormatter(val) {
      switch (val) {
        case "01":
          return "占用中";
        case "02":
          return "借用中";
        case "03":
          return "释放中";
        case "04":
          return "已释放";
        default:
          return "";
      }
    },
    releaseDisposablePeople(row) {
      this.$router.push({
        path: "/bill/ReleaseResource/form",
        query: { id: row.id, isShow: false }
      });
    },
    /**
     *  根据两个时间的差计算出天数
     */
    getEndDate(date1,date2) {
      const date3 = this.$parseDate(date2).getTime() - this.$parseDate(date1).getTime() // 时间差的毫秒数
      // 计算出相差天数
      const days = Math.floor(date3 / (24 * 3600 * 1000))
      return days
    },
      // 项目阶段确认完成任务
    finishTask(scope) {
      deliveryIsFinish(scope.row.id,1).then(res => {
        if (res.code === 200) {
          scope.row.isFinish = 1
          scope.row.actualCompletionTime = new Date()
          this.$notify({ title: "操作成功", type: "success", duration: 2500})
          this.$refs[scope.$index + 'a'].doClose()
        }
      })
    },
    cancel() {
      this.$store.dispatch('tagsView/delView', this.$route)
      this.$router.go(-1);
    },
    // 保存
    save() {
      this.loading = true;
      this.update(this.getFormData())
    },
    /**
     * 导入模板确认
     */
    mbimport(val) {
      idQuery(val.id).then(res => {
        if (res.code === 200) {
          const arr = []
          res.data.bsProjectMilestonePlanList.forEach(ele => {
              const obj = {
                bsMilestoneNode: { name: ele.milestoneNodeName,id: ele.milestoneNode},
                workTargetDetail: ele.workTargetDetail,
                remark: ele.remark,
                keyOutsList: ele.keyOutsList,
                milestoneNode: ele.milestoneNode,
                keyOutput: ele.keyOutsList.map(ele => ele.id).join(",")
              }
              arr.push(obj)
          })
          this.tableData3 = arr
          this.importArr = []
        }
      })
    },
    close() {
       this.stepShow = false;
    },
    // 提交
    submit() {
      this.loading = true;
      this._validateForm(this.validateRefNames).then((res) => {
        getFlowNode({ from: "project_req", id: this.form.id }).then(res => {
           this.loading = false;
          this.personStepData = [];
          if (res.code === 200) {
              this.stepShow = true;
              this.personStepData = res.data;
          }
        }).catch(() => {
          this.loading = false;
        });
    }).catch(e => { this.loading = false; })
    },
    submitConfirm(val) {
      this.loading =  true
      const obj = this.getFormData(2)
      const obj2 = {}
      val.forEach(item => {
        let userList = "";
        item.assignData.forEach(ite => {
          userList = userList + (userList === "" ? ite.id : "," + ite.id);
        });
        obj2[item.key] = userList;
      });
      obj.assignData = JSON.stringify(obj2)
      // console.log('rjuq..',obj)
      this.update(obj)
    },
    update(data) {
      changeProjectDelivery(data).then(res => {
          this.loading = false;
        if (res.code === 200) {
          this.$notify({
            title: "操作成功",
            type: "success",
            duration: 2500
          });
          this.cancel();
        }
      })
    },
    delLaborCosts(index) {
      if (this.tableData[index].id) {
        delLaborCosts(this.tableData[index].id);
        this.tableData.splice(index, 1);
      } else {
        this.tableData.splice(index, 1);
      }
    },
    delChargeDetails(id, scope) {
      if (id) {
        delChargeDetails(id).then(res => {
           this.$refs[scope.$index + 'b'].doClose()
            this.$notify({ title: "删除成功！", type: "success", duration: 1500 });
             this.tableData2.splice(scope.$index, 1);
        });
      } else {
       this.$refs.expense.deleteRows(scope.row)
       this.$refs[scope.$index + 'b'].doClose()
      }
    },
    delMilestonePlans(id, scope) {
      if (id) {
        delMilestonePlans(id).then(res => {
           this.$refs[scope.$index + 'a'].doClose()
            this.$notify({ title: "删除成功！", type: "success", duration: 1500 });
           this.tableData3.splice(scope.$index, 1);
        });
      } else {
        this.$refs.projectStage.deleteRows(scope.row)
        this.$refs[scope.$index + 'a'].doClose()
      }
    },
    delDisposablePeople(id, scope) {
      if (id) {
        delDisposablePeople(id).then(res => {
           this.$refs[scope.$index + 'c'].doClose()
          this.$notify({ title: "删除成功！", type: "success", duration: 1500 });
            this.tableData4.splice(scope.$index, 1);
        });
      } else {
        this.$refs.person.deleteRows(scope.row)
        this.$refs[scope.$index + 'c'].doClose()
      }
    },
    delBonusPlans(index) {
      if (this.tableData5[index].id) {
        delBonusPlans(this.tableData5[index].id);
        this.tableData5.splice(index, 1);
      } else {
        this.tableData5.splice(index, 1);
      }
    },
    delBonuses(index) {
      if (this.tableData6[index].id) {
        delBonuses(this.tableData6[index].id);
        this.tableData6.splice(index, 1);
      } else {
        this.tableData6.splice(index, 1);
      }
    },
    // 组装表单数据提交
    getFormData() {  // 1保存 2提交
      if (this.form.projectObj) {
        // this.form.projectNumber = this.form.projectName.code;
        this.form.projectName = this.form.projectObj.name;
      }
      if (this.form.operatorObj) {
        this.form.operatorName = this.form.operatorObj.name;
        this.form.operator = this.form.operatorObj.id;
      }
      if (this.form.projectManagerObj) {
        this.form.projectManagerName = this.form.projectManagerObj.name;
        this.form.projectManager = this.form.projectManagerObj.id;
      }
      if (this.form.contract) {
        const obj = {}
        obj.contractId = this.form.contract.id
        obj.projectCode = this.form.projectObj.code;
        obj.projectName = this.form.projectObj.name;
        obj.deliveryCode = this.form.code;
        obj.id = this.contractIds
        this.form.contractDelivery = obj
      } else {
         this.form.contractDelivery = {id: this.contractId2}
      }

      // let riskSum  = 0
      // for (const i of this.tableData2) {
      //   this.form.budget += (parseInt(i.budgetAmount) || 0);
      //   this.form.budgetBalance +=
      //    (parseInt(i.budgetAmount) || 0) - (parseInt(i.amountSpent) || 0);
      //   i.balance = parseInt(i.budgetAmount) - parseInt(i.amountSpent) || i.budgetAmount; // 结余金额
      // }
      for (const i of this.tableData3) {
        if (i.expectedStartTime  > i.latestFinishTime) {
            this.loading = false;
           return this.$notify({ title: "项目阶段计划最晚完成时间不能小于预计开始时间！", type: "error", duration: 2500 });
        }
        // riskSum += parseInt(i.riskFund)
        // // 风险金结余= 风险金预算-风险金之和
        // this.form.riskFundBalance = parseInt(this.form.riskFundTotal) - (parseInt(riskSum) || 0)
      }
      if (this.form.contract && this.form.contract !== '' && this.form.contract.totals > 0) {
        const contractTotal = parseFloat(this.form.contract.totals);
        let sumGain = 0.0
        for (const i of this.tableData3) {
          const gain = parseFloat(i.gain)
          if (isNaN(gain) || gain < 0) {
            this.loading =  false;
            return this.$notify({ title: "项目阶段收入金额必须大于等于0", type: "error", duration: 1500 });
          }
            sumGain += gain;
          }
          if (contractTotal < sumGain) {
            this.loading =  false;
            return this.$notify({ title: "项目阶段收入合计必须不能大于合同金额" + contractTotal, type: "error", duration: 1500 });
          }
      }
        // 费用预算 + 人工目标成本不能大于交付成本！
       const total = (parseInt(this.form.budget) || 0)  + parseInt(this.form.targetCost)
      //  console.log('total..',total,this.form.costBudgeting)
      if (total > this.form.costBudgeting) {
        this.loading = false;
        return this.$notify({ title: "费用预算加人工目标成本不能大于交付成本！", type: "error", duration: 2500 });
      }
      if (status === 2 && this.tableData3.length <= 0) {
        this.loading = false;
        return this.$notify({ title: "项目阶段计划不能为空！", type: "error", duration: 2500 });
      }
      //  for (let i = 0; i++; i < this.tableData4.length) {
      //   for (let o = i + 1; o++; o < this.tableData4.length) {
      //       console.log(this.tableData4[i].id,this.tableData4[o].id)
      //     if (this.tableData4[i].id === this.tableData4[o].id) {
      //       return  this.$notify({ title: "可支配人员不能重复！", type: "error", duration: 2500 });
      //     }
      //   }
      // }
      const obj = {};
      obj.status = status;
      obj.projectDelivery = this.form;
      if (status === 2) { // HR审批提交人信息
        obj.from = "project_req"
        // obj.assignData = JSON.stringify(this.assignData)
      }
      obj.laborCosts = this.tableData;
      obj.chargeDetails = this.tableData2;
      obj.milestonePlans = this.tableData3;
      obj.disposablePersonList = this.tableData4;
      obj.bonusPlans = this.tableData5;
      obj.bonuses = this.tableData6;
      return obj
    },
    // 项目阶段是否可编辑
    activeMethod({ row, rowIndex, column, columnIndex }) {
      if (row.id && ['expectedStartTime','latestFinishTime'].includes(column.property)) {
        return false
      }
      return true
    },
  }
};
</script>

<style lang="scss" scoped>
.app-container {
  .box-card {
    background-color: #fff;
    padding: 20px 30px 20px 30px;
    border-radius: 10px;

    .content-title {
      height: 40px;
      background-color: #e7eff6;
      padding-left: 20px;
      overflow: hidden;

      .title-icon {
        display: inline-block;
        margin-top: 8px;
        width: 6px;
        height: 24px;
        background-color: #1369a8;
        margin-right: 14px;
      }

      .title-details {
        overflow: hidden;
        line-height: 20px;
        display: inline-block;
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        font-family: SourceHanSansSC-regular;
      }
    }

    .button {
      padding-top: 20px;
      text-align: right;

      .btn-submit {
        width: 80px;
        height: 38px;
        background: #1369a8;
        color: white;
      }

      .btn-cancel {
        width: 80px;
        height: 38px;
        background: #fff;
      }
    }
  }
}
</style>
